class CartDrawer extends DrawerFixed {
  constructor() {
    super();
  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    // The header cart icon is already a native <a href="{{ routes.cart_url }}">.
    // Do not turn it into a dialog button or hijack its click/keyboard events.
    // Only explicit trade-in triggers may open the SellMac drawer.
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.removeAttribute('role');
    cartLink.removeAttribute('aria-haspopup');
  }
   open(triggeredBy) {
    // This drawer now holds the SellMac trade-in iframe, not the shopping cart.
    // Any ordinary cart-opening call must lead to the full cart page.
    const tradeInTrigger = triggeredBy && typeof triggeredBy.closest === 'function'
      ? triggeredBy.closest('.access-tarde-in, .tq-cart-trade-cta, [data-techable-tradein-open]')
      : null;
    if (!tradeInTrigger && !window.__tqTradeinIntroOpening) {
      window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      return;
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.updateProductRecommendation();
    super.open(triggeredBy);
  }
  close(evt) {
    if (window.__tqTradeinIntroVisible) {
      window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      return;
    }
    const currentFooterAction = this.querySelector('cart-drawer-footer-action.open');
    if(currentFooterAction) {
      currentFooterAction.closeActionContent();
    }
    if(!this.classList.contains('busy') || !(evt && evt.target && evt.target.closest && evt.target.closest('cart-drawer-footer-action'))) {
      super.close(evt);
    }    
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
  cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
 // Offer the one-time trade-in introduction after a successful add-to-cart.
    // Automatic trade-in intro disabled for cart conversion test (2026-10-25). Manual opt-in remains available.
    window.location.assign((window.routes && window.routes.cart_url) || '/cart');
  }
  showTradeinIntro(sectionHtml, addedState) {
    try { if (sessionStorage.getItem('tq_tradein_intro_seen') === '1') return false; }
    catch (error) { return false; }
    if (!sectionHtml || !addedState) return false;
    const source = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const template = source.querySelector('template[data-tq-tradein-intro]');
    if (!template) return false;
    const eligibleIds = template.dataset.eligibleVariants.split(',').filter(Boolean);
    const addedItems = Array.isArray(addedState.items) ? addedState.items : [addedState];
    const addedIds = addedItems.map(item => String(item.variant_id || item.id || ''));
    if (!addedIds.some(id => eligibleIds.includes(id))) return false;
    const host = this.querySelector('#CartDrawer');
    const inner = this.querySelector('.drawer__inner--cart');
    const panel = template.content.querySelector('#tq-tradein-prelude')?.cloneNode(true);
    if (!host || !inner || !panel) return false;
    this.querySelector('#tq-tradein-prelude')?.remove();
    inner.prepend(panel);
    inner.setAttribute('aria-labelledby', 'tq-tradein-question');
    panel.querySelector('.tq-yes').addEventListener('click', () => {
      window.__tqTradeinIntroVisible = false;
      host.classList.remove('tq-tradein-intro-open');
      inner.removeAttribute('aria-labelledby');
      inner.setAttribute('aria-label', template.dataset.dialogLabel);
      panel.remove();
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.setAttribute('data-techable-tradein-open', '');
      document.body.append(trigger);
      trigger.click();
      trigger.remove();
    });
    window.__tqTradeinIntroVisible = true;
    host.classList.add('tq-tradein-intro-open');
    window.__tqTradeinIntroOpening = true;
    try { super.open(); } finally { window.__tqTradeinIntroOpening = false; }
    try { sessionStorage.setItem('tq_tradein_intro_seen', '1'); } catch (error) {}
    inner.scrollTop = 0;
    return true;
  }
  updateProductRecommendation() {
    this.productRecommendation = this.querySelector('cart-product-recommendations');
    if(this.productRecommendation) {
      const cartItemsWrapper = this.querySelector('.cart-drawer__items');
      cartItemsWrapper.classList.toggle('cart-drawer__items--large', cartItemsWrapper.querySelectorAll('.cart-item').length > 1);
      this.productRecommendation.update();
    }
  }
 getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        section: 'CartDrawer',
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        section: 'CartDrawer',
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        section: 'cart-icon-bubble',
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
updateProductRecommendation() {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if(cartDrawerWrapper) {
      cartDrawerWrapper.updateProductRecommendation();
    }
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
class CartDrawerFooterAction extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.cart-drawer__footer__action-label');
    this.content = this.querySelector('.cart-drawer__footer__action-content');
    this.closeButton = this.content.querySelector('.cart-drawer__footer__action-close');
    this.openButton.addEventListener('click', this.onClickFooterAction.bind(this));
    this.closeButton.addEventListener('click', this.closeActionContent.bind(this));
    this.cartDrawer = this.closest('.drawer__inner');
  }
  onClickFooterAction(event) {
    const isOpen = this.classList.contains('open');
    isOpen ? this.closeActionContent(event) : this.openActionContent(); 
  }
 openActionContent() {
    this.style.setProperty('--drawer-bottom-position', `${Math.floor(this.cartDrawer.scrollTop)}px`);
    this.classList.add('open');
    this.content.classList.add('appear')
    setTimeout(() => {this.content.classList.add('animate')}, 1);
    setTimeout(() => {this.content.querySelector('textarea,select').focus();}, 300);
    this.closest('cart-drawer').classList.add('busy');
  }
 closeActionContent() {
    this.classList.remove('open');
    this.content.classList.remove('animate');
    setTimeout(() => {
      this.content.classList.remove('appear');
      const cartDrawer = this.closest('cart-drawer');
      cartDrawer.classList.remove('busy');
      trapFocus(cartDrawer, this.openButton);
    }, 300);
  }
}
customElements.define('cart-drawer-footer-action', CartDrawerFooterAction);
class CartDrawerNote extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('textarea');
    this.button = this.querySelector('.button');
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const body = JSON.stringify({ note: this.input.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      this.closest('cart-drawer-footer-action').closeActionContent();
    }, false);
  }
}
customElements.define('cart-drawer-note', CartDrawerNote);
